export var OrderLineRefundStatus;
(function(OrderLineRefundStatus) {
    OrderLineRefundStatus[/**
     * Order line has not been refunded.
     */ "NotRefunded"] = "NotRefunded";
    OrderLineRefundStatus[/**
     * Order line has been refunded.
     */ "Refunded"] = "Refunded";
})(OrderLineRefundStatus || (OrderLineRefundStatus = {}));

//# sourceMappingURL=order-line-refund-status.js.map